var map = {
	"./sample.abap.txt": [
		86653,
		6653
	],
	"./sample.aes.txt": [
		9547,
		9547
	],
	"./sample.apex.txt": [
		39365,
		9365
	],
	"./sample.azcli.txt": [
		87795,
		7795
	],
	"./sample.bat.txt": [
		20470,
		470
	],
	"./sample.bicep.txt": [
		10803,
		803
	],
	"./sample.brainfuck.txt": [
		78465,
		8465
	],
	"./sample.c.txt": [
		86124,
		6124
	],
	"./sample.cameligo.txt": [
		64286,
		4286
	],
	"./sample.clike.txt": [
		25034,
		5034
	],
	"./sample.clojure.txt": [
		6268,
		6268
	],
	"./sample.coffeescript.txt": [
		35164,
		5164
	],
	"./sample.cpp.txt": [
		78410,
		8410
	],
	"./sample.csharp.txt": [
		57511,
		7511
	],
	"./sample.csp.txt": [
		55541,
		5541
	],
	"./sample.css.txt": [
		80088
	],
	"./sample.dart.txt": [
		84661,
		4661
	],
	"./sample.dockerfile.txt": [
		24593,
		4593
	],
	"./sample.ecl.txt": [
		83733,
		3733
	],
	"./sample.elixir.txt": [
		84890,
		4890
	],
	"./sample.erlang.txt": [
		48453,
		8453
	],
	"./sample.flow9.txt": [
		97626,
		7626
	],
	"./sample.freemarker2.txt": [
		33498,
		3498
	],
	"./sample.fsharp.txt": [
		96787,
		6787
	],
	"./sample.go.txt": [
		11200
	],
	"./sample.graphql.txt": [
		11093,
		1093
	],
	"./sample.handlebars.txt": [
		8884,
		8884
	],
	"./sample.hcl.txt": [
		64166,
		4166
	],
	"./sample.html.txt": [
		90348
	],
	"./sample.ini.txt": [
		82424,
		2424
	],
	"./sample.java.txt": [
		73486
	],
	"./sample.javascript.txt": [
		11039
	],
	"./sample.json.txt": [
		20230
	],
	"./sample.jsx.txt": [
		33528
	],
	"./sample.julia.txt": [
		47610,
		7610
	],
	"./sample.kotlin.txt": [
		90671,
		671
	],
	"./sample.less.txt": [
		68152,
		8152
	],
	"./sample.lex.txt": [
		43787,
		3787
	],
	"./sample.lexon.txt": [
		81033,
		1033
	],
	"./sample.liquid.txt": [
		24905,
		4905
	],
	"./sample.livescript.txt": [
		41108,
		1108
	],
	"./sample.lua.txt": [
		28660,
		8660
	],
	"./sample.m3.txt": [
		27695,
		7695
	],
	"./sample.markdown.txt": [
		79770
	],
	"./sample.mips.txt": [
		55942,
		5942
	],
	"./sample.msdax.txt": [
		93087,
		3087
	],
	"./sample.mysql.txt": [
		55718
	],
	"./sample.nginx.txt": [
		64272,
		4272
	],
	"./sample.objective-c.txt": [
		6401,
		6401
	],
	"./sample.pascal.txt": [
		99476,
		9476
	],
	"./sample.pascaligo.txt": [
		8569,
		8569
	],
	"./sample.perl.txt": [
		96466,
		6466
	],
	"./sample.pgsql.txt": [
		78031,
		8031
	],
	"./sample.php.txt": [
		17995
	],
	"./sample.pla.txt": [
		69321,
		9321
	],
	"./sample.plaintext.txt": [
		10602,
		602
	],
	"./sample.postiats.txt": [
		10428,
		428
	],
	"./sample.powerquery.txt": [
		6580,
		6580
	],
	"./sample.powershell.txt": [
		79336,
		9336
	],
	"./sample.proto.txt": [
		81600,
		1600
	],
	"./sample.pug.txt": [
		63834,
		3834
	],
	"./sample.python.txt": [
		2223
	],
	"./sample.qsharp.txt": [
		24668,
		4668
	],
	"./sample.r.txt": [
		74199,
		4199
	],
	"./sample.razor.txt": [
		91876,
		1876
	],
	"./sample.redis.txt": [
		13368,
		3368
	],
	"./sample.redshift.txt": [
		23969,
		3969
	],
	"./sample.restructuredtext.txt": [
		76203,
		6203
	],
	"./sample.ruby.txt": [
		53602,
		3602
	],
	"./sample.rust.txt": [
		74922
	],
	"./sample.sb.txt": [
		16365,
		6365
	],
	"./sample.scala.txt": [
		15194,
		5194
	],
	"./sample.scheme.txt": [
		80721,
		721
	],
	"./sample.scss.txt": [
		14695,
		4695
	],
	"./sample.shell.txt": [
		69512
	],
	"./sample.sol.txt": [
		71419,
		1419
	],
	"./sample.sparql.txt": [
		99308,
		9308
	],
	"./sample.sql.txt": [
		49347,
		9347
	],
	"./sample.st.txt": [
		66488,
		6488
	],
	"./sample.stylus.txt": [
		10877,
		877
	],
	"./sample.swift.txt": [
		31027
	],
	"./sample.systemverilog.txt": [
		84887,
		4887
	],
	"./sample.tcl.txt": [
		46636,
		6636
	],
	"./sample.toml.txt": [
		32980,
		2980
	],
	"./sample.tsx.txt": [
		17251
	],
	"./sample.twig.txt": [
		31635,
		1635
	],
	"./sample.typescript.txt": [
		53992
	],
	"./sample.vb.txt": [
		44187,
		4187
	],
	"./sample.vbscript.txt": [
		19200,
		9200
	],
	"./sample.verilog.txt": [
		94124,
		4124
	],
	"./sample.vue.txt": [
		10310,
		310
	],
	"./sample.xml.txt": [
		49294,
		9294
	],
	"./sample.yaml.txt": [
		89896,
		9896
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70620;
module.exports = webpackAsyncContext;